import Model from "./model";
import User from "./User";
import ApiBarrelUser from "../../foundation/api/model/barrels/BarrelUser";

class BarrelUser extends Model {
    role: string;
    user: User;

    constructor(userData: ApiBarrelUser) {
        super();

        const {
            role,
            user
        } = userData;

        this.role = role;
        this.user = new User(user);
    }
}

export default BarrelUser;
